export default __webpack_public_path__ + "static/media/unit-result-2.08af6fba.mp3";